import { createTheme, PaletteOptions } from "@mui/material";
import { equals } from "ramda";

import { RoutePaths } from "src/app/model/routes";

export const theme = (pathname: string) => {
  const greenPalette: PaletteOptions = {
    primary: { main: "#3db492", contrastText: "#ffffff" },
    secondary: { main: "#565656", contrastText: "#ffffff" },
    background: {
      default: "#000000",
      paper: "#000000",
    },
    text: {
      primary: "#ffffff7d",
      secondary: "#ffffff",
    },
    action: {
      hover: "#ffffff",
      active: "#3db492",
      selected: "#444444",
      disabled: "#292929",
    },
    warning: { main: "#dbeeff", contrastText: "#ffa726" },
    info: { main: "#004480" },
    common: {
      white: "#ffffff",
      black: "#000000",
    },
  };

  const bluePalette: PaletteOptions = {
    primary: { main: "#518bf1", contrastText: "#ffffff" },
    secondary: { main: "#565656", contrastText: "#ffffff" },
    background: {
      default: "#000000",
      paper: "#000000",
    },
    text: {
      primary: "#ffffff7d",
      secondary: "#ffffff",
    },
    action: {
      hover: "#ffffff",
      active: "#518bf1",
      selected: "#444444",
      disabled: "#292929",
    },
    warning: { main: "#dbeeff", contrastText: "#ffa726" },
    info: { main: "#004480" },
    common: {
      white: "#ffffff",
      black: "#000000",
    },
  };
  return createTheme({
    typography: {
      fontFamily: `'Questrial', sans-serif`,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
    },
    palette: equals(
      pathname.replace(/^\/(en|de)(?=\/|$)/, "") || "/",
      RoutePaths.TOOLS,
    )
      ? greenPalette
      : bluePalette,
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "capitalize",
            "&.Mui-disabled": {
              backgroundColor: "rgba(140, 143, 148, 0.4)",
              color: "#8C8F94",
            },
          },
        },
      },
    },
  });
};
